import image01 from '../assets/accordion-img/1.jpg';
import image02 from '../assets/accordion-img/2.jpg';
import image03 from '../assets/accordion-img/3.jpg';
import image04 from '../assets/accordion-img/4.jpg';
import image05 from '../assets/accordion-img/5.jpg';
import image06 from '../assets/accordion-img/6.jpg';
import image07 from '../assets/accordion-img/7.jpg';
import image08 from '../assets/accordion-img/8.jpg';
import image09 from '../assets/accordion-img/9.jpg';
import image10 from '../assets/accordion-img/10.jpg';
import image11 from '../assets/accordion-img/11.jpg';
import image12 from '../assets/accordion-img/12.jpg';
import image13 from '../assets/accordion-img/13.jpg';
import image14 from '../assets/accordion-img/14.jpg';
import image15 from '../assets/accordion-img/15.jpg';
import image16 from '../assets/accordion-img/16.jpg';
import image17 from '../assets/accordion-img/17.jpg';
import image18 from '../assets/accordion-img/18.jpg';
import image19 from '../assets/accordion-img/19.jpg';
import image20 from '../assets/accordion-img/20.jpg';
import image21 from '../assets/accordion-img/21.jpg';
import image22 from '../assets/accordion-img/22.jpg';


const Images = [
  image01,
  image02,
  image03,
  image04,
  image05,
  image06,
  image07,
  image08,
  image09,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
  image18,
  image19,
  image20,
  image21,
  image22,
]

export default Images